<template>

</template>

<script>

export default {
	name: "TrainingGroup",

	props: {},
	components: {},
	data() {
		return {}
	},
	mounted() {

	},
	methods: {},
	watch: {}
}
</script>

<style scoped>

</style>